import React, {useEffect, useState} from 'react';
import * as util from "../../utils/util";
import api from "../../utils/api";
import {Box, Grid, Typography} from "@mui/material";
import Top from "../Top";
import Bottom from "../Bottom";
import Circle from "../../components/CircleProgress";
import HistoryMonthChart from "../../components/HistoryMonthChart";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import {useLocation} from "react-router-dom";

const initMonthInfo = {
  RECORD_COUNT: 0,  // 기록 일수
  COMPLETE_PERCENT: 0,  // 목표 달성률
  COMPLETE_COUNT: 0,  // 목표 달성 일수
  TARGET_AVG: 0,  // 평균 목표 값
  VALUE_AVG: 0,  // 평균 값
}

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const MonthHistory = () => {
  const [monthInfo, setMonthInfo] = React.useState(initMonthInfo);
  const [monthValue, setMonthValue] = useState(new Date().getMonth() + 1);
  const [monthSeries, setMonthSeries] = React.useState([{}]);
  const [title, setTitle] = React.useState('');
  const [unit, setUnit] = React.useState('');
  const {state} = useLocation();
  const {type} = state ?? {};

  useEffect(() => {
    setMonthData();
  }, [monthValue]);

  function setMonthData() {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      const date = new Date();
      const month = date.getFullYear() + '-' + (('00'+monthValue.toString()).slice(-2));
      api.get(`app/api/v1/AP_002_013?type=${type}&month=${month}`).then(res => {
        setMonthInfo(res.data.result_data.info);
      }).catch(function (error) {
        console.log(error)
      });
      
      params.token = localStorage.getItem('token') || '';
      params.from = date.getFullYear() + (('00'+monthValue.toString()).slice(-2)) + '01';
      params.to = date.getFullYear() + (('00'+monthValue.toString()).slice(-2)) + '31';
      params.target = util.getDateByCustom('yyyyMMdd', 0);
      
      let apiUrl = '';
      if(type === 'meal') {apiUrl = 'app/api/v1/AP_002_002'; setTitle('식사'); setUnit('kcal');}
      else if(type === 'exercise') {apiUrl = 'app/api/v1/AP_002_003'; setTitle('운동'); setUnit('kcal');}
      else if(type === 'moisture') {apiUrl = 'app/api/v1/AP_002_004'; setTitle('수분 섭취'); setUnit('잔');}
      else if(type === 'step') {apiUrl = 'app/api/v1/AP_002_005'; setTitle('걸음수'); setUnit('step');}
      
      api.get(`${apiUrl}?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
        if (res.data.result_code === '0') {
          let tempArr = [];
          let monthSeriesTemp = [{}];
          if(type === 'meal') {
            tempArr = getCaloryDataset(res.data.result_data.data);
            monthSeriesTemp = [
              { type: 'bar', data: tempArr.map((v: any) => v.morning), stack: 'total', label: '아침' },
              { type: 'bar', data: tempArr.map((v: any) => v.lunch), stack: 'total', label: '점심' },
              { type: 'bar', data: tempArr.map((v: any) => v.dinner), stack: 'total', label: '저녁' },
              { type: 'bar', data: tempArr.map((v: any) => v.snack), stack: 'total', label: '간식' },
              { type: 'line', data: tempArr.map((v: any) => v.target), stack: 'total', label: '목표' }
            ];
          } else if(type === 'exercise') {
            tempArr = [];
            for (let item of res.data.result_data.data.calory_v2) {
              let obj = { target: 0, calory: 0, month: '' };
              obj.month = item.date;
              obj.calory = item.calory;
              obj.target = item.target;
              tempArr.push(obj);
            }
            monthSeriesTemp = [
              { type: 'bar', data: tempArr.map((v: any) => v.calory), stack: 'total', label: '운동량', color:'#ff5454' },
              { type: 'line', data: tempArr.map((v: any) => v.target), stack: 'total', label: '목표', color:'#0093ff' }
            ];
          } else if(type === 'moisture') {
            tempArr = [];
            for (let item of res.data.result_data.data.moisture_v2) {
              let obj = { target: 0, moisture: 0, month: '' };
              obj.month = item.date;
              obj.moisture = item.moisture;
              obj.target = item.target;
              tempArr.push(obj);
            }
            monthSeriesTemp = [
              { type: 'bar', data: tempArr.map((v: any) => v.moisture), stack: 'total', label: '수분', color:'#33cccc' },
              { type: 'line', data: tempArr.map((v: any) => v.target), stack: 'total', label: '목표', color:'#0093ff' }
            ];
          } else if(type === 'step') {
            tempArr = [];
            for (let item of res.data.result_data.data.step_v2) {
              let obj = { target: 0, step: 0, month: '' };
              obj.month = item.date;
              obj.step = item.step;
              obj.target = item.target;
              tempArr.push(obj);
            }
            monthSeriesTemp = [
              { type: 'bar', data: tempArr.map((v: any) => v.step), stack: 'total', label: '걸음수', color:'#e029ff' },
              { type: 'line', data: tempArr.map((v: any) => v.target), stack: 'total', label: '목표', color:'#0093ff' }
            ];
          }
          
          setMonthSeries(monthSeriesTemp); // 월간현황 차트 series 세팅
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }
  
  // 섭취 칼로리 바차트 데이터 설정
  function getCaloryDataset(resData: any) {
    let tempArr = [];
    const series = ['morning', 'lunch', 'dinner', 'snack', 'target'];
    const monthArr = resData.morning_v2.map((item: any) => item.x);
    let index = 0;

    for (let sr of series) {
      for (let item of resData[sr + '_v2']) {
        index++;
        let obj = { morning: 0, lunch: 0, dinner: 0, snack: 0, target:0, month: monthArr[index] };
        if (sr === 'morning') {
          obj.month = item.x;
          // @ts-ignore
          obj[sr] = item.y;
          tempArr.push(obj)
        } else {
          // @ts-ignore
          tempArr.find((v: any) => v.month === item.x)[sr] = item.y;
        }
      }
    }
    return tempArr;
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title={'월간 '+title+' 기록'} />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%',}}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setMonthValue((prev) => prev - 1)} sx={{ 'display': monthValue > 1 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
            {new Date().getFullYear() + '년 ' + monthValue + '월'}
            <ArrowRightIcon onClick={() => setMonthValue((prev) => prev + 1)} sx={{ 'display': monthValue < new Date().getMonth() + 1 && monthValue > 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Box sx={{
              '& .CircleChart .MuiGauge-root': { width: '180px', height: '180px' },
              '& .CircleChart .circleText': { fontSize: 24, },
            }}>
              <Circle progress={{ goal: 100, value: monthInfo.COMPLETE_PERCENT, type: 'month' }} />
            </Box>

            <Box sx={{ mb: 2 }}>
              {
                monthInfo.RECORD_COUNT > 0 ? (
                  monthInfo.COMPLETE_PERCENT === 100 ? (
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                      <SentimentSatisfiedAltIcon sx={{ fontSize: 30, color: '#ef8322', mb: 1 }} />
                      <Typography sx={{ fontSize: 14, color: '#ef8322', fontWeight: 700 }}>{title} 조절을 잘 하고 있어요</Typography>
                    </Stack>
                  ) : (
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                      <SentimentNeutralIcon sx={{fontSize:30, color:'#ef8322', mb:1}}  />
                      <Typography sx={{ fontSize: 14, color: '#555',fontWeight: 700  }}>목표달성의 {100 - Math.round(monthInfo.COMPLETE_PERCENT)}%가 부족해요</Typography>
                    </Stack>
                  )
                ) : (
                  <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                    <SentimentVeryDissatisfiedIcon sx={{fontSize:30, color:'#999', mb:1}} />
                    <Typography sx={{ fontSize: 14, color: '#777', fontWeight: 700 }}>아직 기록이 없어요</Typography>
                  </Stack>
                )
              }
            </Box>

            <Stack direction={'row'} justifyContent={'space-evenly'} alignItems={'center'} sx={{ width: '100%', mb:1 }}>
              <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} >
                <Typography sx={{ fontSize: 14, color: '#555', }}>일일 평균 {title}량</Typography>
                <Typography component="div" sx={{ fontSize: 20, color: '#777', fontWeight: 700 }}>
                  {util.formatComma(monthInfo.VALUE_AVG)}
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', ml: 1, }}>{unit}</Typography>
                </Typography>
              </Stack>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                <Typography sx={{ fontSize: 14, color: '#555', }}>목표 달성일</Typography>
                <Typography component="div" sx={{ fontSize: 20, color: '#777', fontWeight: 700 }}>
                  {util.formatComma(monthInfo.COMPLETE_COUNT)}
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', ml: 1, }}>일</Typography>
                </Typography>
              </Stack>
            </Stack>
{/*
            <Stack direction={'row'} justifyContent={'space-evenly'} sx={{ bgcolor: '#f5f5f5', borderRadius: 3, m: 2, width:'100%' }}>
              <Box sx={{ py: 1, px: 2, textAlign: 'center', }}>
                <Typography sx={{ fontSize: 14, color: '#777', }}>아침</Typography>
                <Typography sx={{ fontSize: 14, color: '#333', }}>1,545</Typography>
              </Box>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Box sx={{ py: 1, px: 2, textAlign: 'center', }}>
                <Typography sx={{ fontSize: 14, color: '#777', }}>점심</Typography>
                <Typography sx={{ fontSize: 14, color: '#333', }}>1,545</Typography>
              </Box>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Box sx={{ py: 1, px: 2, textAlign: 'center',  }}>
                <Typography sx={{ fontSize: 14, color: '#777', }}>저녁</Typography>
                <Typography sx={{ fontSize: 14, color: '#333', }}>1,545</Typography>
              </Box>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Box sx={{ py: 1, px: 2, textAlign: 'center' }}>
                <Typography sx={{ fontSize: 14, color: '#777', }}>간식</Typography>
                <Typography sx={{ fontSize: 14, color: '#333', }}>1,545</Typography>
              </Box>
            </Stack>
*/}

          </Stack>


          <Box sx={{ bgcolor: '#fff', p: '10px 10px 20px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight:700 }}>월간현황</Typography>
              </Stack>
            </Stack>
            <Box sx={{textAlign:'center', mb:2}}>
              <Typography component="div" sx={{ fontSize: 12, color: '#555', mr: .5,}}>이번 달의
                <Typography component="span" sx={{ fontSize: 14, color: '#0069ce', fontWeight: 700, mb: 2,  }}> {title} </Typography>
                기록이에요.
              </Typography>

              {/* <Typography component="div" sx={{ fontSize: 16, color: '#5173f9', fontWeight: 700, mb: 2, }}>
              <Typography component="span" sx={{ fontSize: 12, color: '#555', mr: 1, }}>저번달 보다</Typography>
              <ArrowDownwardIcon sx={{ fontSize: 18, verticalAlign: 'text-bottom' }} /> 20%
              <Typography component="span" sx={{ fontSize: 12, color: '#555', ml: 1, }}>감소 했어요</Typography>
            </Typography> */}
            </Box>
            <Divider />

            <Box sx={{ mt: -3.5 }}>
              <HistoryMonthChart targetMonth={monthValue} monthSeries={monthSeries} />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

export default MonthHistory;